/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S6_Li3Inputs */

const tr_servis_s6_li3 = /** @type {(inputs: Servis_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF (e-Fatura kopyaları ve raporlar)`)
};

const en_servis_s6_li3 = /** @type {(inputs: Servis_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF (e-Fatura copies and reports)`)
};

const de_servis_s6_li3 = /** @type {(inputs: Servis_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF (e-Fatura-Kopien und Berichte)`)
};

const ru_servis_s6_li3 = /** @type {(inputs: Servis_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF (копии e-Fatura и отчеты)`)
};

/**
* | output |
* | --- |
* | "PDF (e-Fatura copies and reports)" |
*
* @param {Servis_S6_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s6_li3 = /** @type {((inputs?: Servis_S6_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S6_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s6_li3(inputs)
	if (locale === "de") return de_servis_s6_li3(inputs)
	if (locale === "ru") return ru_servis_s6_li3(inputs)
	return tr_servis_s6_li3(inputs)
});